var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.99998C14.341 9.99998 15.8334 8.5076 15.8334 6.66665C15.8334 4.8257 14.341 3.33331 12.5 3.33331C10.6591 3.33331 9.16669 4.8257 9.16669 6.66665C9.16669 8.5076 10.6591 9.99998 12.5 9.99998Z",
    fill: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.6666C12.5 16.6666 19.1666 16.6666 19.1666 15C19.1666 13 15.9166 10.8333 12.5 10.8333C9.08331 10.8333 5.83331 13 5.83331 15C5.83331 16.6666 12.5 16.6666 12.5 16.6666Z",
    fill: "#4F4F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99998 8.33331V5.83331H3.33331V8.33331H0.833313V9.99998H3.33331V12.5H4.99998V9.99998H7.49998V8.33331H4.99998Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/user-add.b27a27bd2d63f14a483450cceda0fdee.svg";
export { ForwardRef as ReactComponent };